import { defineStore } from 'pinia'

export const useBalanceStore = defineStore('balanceInfo', {
  state: () => ({
    // 账户总余额
    balance: 0,
    // 今日个人收益
    todayReward: 0,
    // 今日代理收益
    todayReward_Agente: 0,
  }),

  actions: {
    /**
     * 设置总余额
     * @param {number} val 新余额值
     */
    setBalance(val) {
      this.balance = Number(val)
    },

    /**
     * 累加余额
     * @param {number} val 增加金额
     */
    addBalance(val) {
      this.balance += Number(val)
    },

    /**
     * 设置今日个人收益
     * @param {number} val 收益值
     */
    setTodayReward(val) {
      this.todayReward = Number(val)
    },

    /**
     * 累加今日个人收益
     * @param {number} val 新增收益
     */
    addTodayReward(val) {
      this.todayReward += Number(val)
    },

    /**
     * 设置今日代理收益
     * @param {number} val 代理收益值
     */
    setTodayRewardAgente(val) {
      this.todayReward_Agente = Number(val)
    },

    /**
     * 累加今日代理收益
     * @param {number} val 新增代理收益
     */
    addTodayRewardAgente(val) {
      this.todayReward_Agente += Number(val)
    },

    /**
     * 重置所有状态到初始值
     */
    resetState() {
      this.balance = 0
      this.todayReward = 0
      this.todayReward_Agente = 0
    },
  },

  persist: false,
  // persist: {
  //   key: 'balance-store',
  //   storage: localStorage,
  //   paths: ['balance', 'todayReward', 'todayReward_Agente'],
  // },
})
